import { apiClient } from '@api/apiClient';

import type { AiRecommendationPolicyDto, EscalationCaseDto } from './types';

type ApiResult<T> = {
  value?: T;
};

export function unwrapResult<T>(data: unknown): T {
  if (
    data &&
    typeof data === 'object' &&
    'value' in (data as Record<string, unknown>)
  ) {
    return ((data as ApiResult<T>).value ?? data) as T;
  }
  return data as T;
}

const POLICY_BASE = '/policies/ai-safety';

export async function getAiPolicy(): Promise<AiRecommendationPolicyDto> {
  const res = await apiClient.get<
    AiRecommendationPolicyDto | ApiResult<AiRecommendationPolicyDto>
  >(POLICY_BASE);
  return unwrapResult<AiRecommendationPolicyDto>(res);
}

export async function updateAiPolicy(
  policy: Partial<AiRecommendationPolicyDto>,
): Promise<AiRecommendationPolicyDto> {
  const res = await apiClient.put<
    AiRecommendationPolicyDto | ApiResult<AiRecommendationPolicyDto>
  >(POLICY_BASE, policy);
  return unwrapResult<AiRecommendationPolicyDto>(res);
}

export async function listEscalations(
  status?: 'Open' | 'Resolved',
): Promise<EscalationCaseDto[]> {
  const res = await apiClient.get<
    EscalationCaseDto[] | ApiResult<EscalationCaseDto[]>
  >(`${POLICY_BASE}/escalations`, {
    params: status ? { status } : undefined,
  });
  return unwrapResult<EscalationCaseDto[]>(res);
}

export async function resolveEscalation(id: number): Promise<unknown> {
  const res = await apiClient.post<unknown | ApiResult<unknown>>(
    `${POLICY_BASE}/escalations/${id}/resolve`,
  );
  return unwrapResult<unknown>(res);
}
